@if (crumbs().length > 0) {
  <nav data-testid="breadcrumb" class="flex items-center gap-1 text-sm text-gray-500 mb-4">
    @for (crumb of crumbs(); track crumb.path; let last = $last) {
      @if (!last) {
        <button (click)="navigate(crumb)" class="hover:text-blue-600 transition-colors">
          {{ crumb.label }}
        </button>
        <span class="text-gray-300">/</span>
      } @else {
        <span class="text-gray-800 font-medium">{{ crumb.label }}</span>
      }
    }
  </nav>
}
